// 合约地址
export const contractAddressArr = [
  { address: "0x", unit: "DTT" },
  { address: "0x0", unit: "DTT" },
  { address: "0x6462c508286747c1a882a169f99ce717f337f132", unit: "DTT" },
  { address: "0x29cd7748359965fd1cbb035d824b862046a66d4a", unit: "DTT" },
  { address: "0xbdd381d0c9fa6e059674d67a8fc47f2837c2f98a", unit: "DTT" },
  { address: "0xe52a736828c782c2a4a345bbe8052aed010fc82d", unit: "HLT" },
  { address: "0x9fa03dfc03dc965759196231efcc425c8085ce46", unit: "HLT" },
  { address: "0x36e6504c968f5c2a310b6af7b97bc22cdd3402cc", unit: "dUSDT" },
  { address: "0x99bc001a7e274775dcc28eb4283b015cb69840e4", unit: "dUSDT" },
  { address: "0x747294d3e04c1ad8b4897bc6fdab72bfa9b5c3f4", unit: "dUSDT" },
  { address: "0xe895c577d747bb5dbbc1f06cb44d6067680be4be", unit: "dBTC" },
  { address: "0xb6476d01b67bce545923d31e731cbae3860af315", unit: "dBTC" },
  { address: "0x8b7160c1e9fdb689a060ff0919e84915b0dfa04a", unit: "dETH" },
  { address: "0x7d0a5f4cb8ab14525dd8de6703126dae0f7d551b", unit: "dETH" },
  { address: "0x745c11fb4783bd00a88a0b99420262f409fa8bb8", unit: "DOS" },
  { address: "0x16da992c608fdb38966c77b93c1f301d995f9b17", unit: "DOS" },
  { address: "0x899f0b9d67dd1b833fdaa90c8b09ea616d0e9e98", unit: "CNV" },
  { address: "0x2cb76cce32acda7263262117df1bd02ec54dcf5c", unit: "CNV" },
  { address: "0xb88ad767b416197e62939dec207431b561a9383b", unit: "FEC" },
  { address: "0x70b250ba5f197f8c426ee3b92c009a096bd802f9", unit: "FEC" },
  { address: "0xf5da17e859e8798157bc401e47d9acd9485ae422", unit: "FEC" },
  { address: "0xb5c5fc0a81dc746a8f29d88bb384bfd3c23980eb", unit: "FEC" },
  { address: "0x8e79850c50e525eb6ba63e601e7b41888a1c9102", unit: "BV" },//BV的代币地址
  { address: "0x66821e8c2318abf134c326b285bb5b363ed42b01", unit: "BV" },//BV质押的智能合约地址
  { address: "0x65fbc0125287689c81be9138979a17543aa63d9f", unit: "BV" },
  { address: "0x3a6ddce9693485142928c47593fce2b5100ba5d3", unit: "BV" },
  { address: "0xa9a582bafc13c7fb7afd64af96de9e90b0c76b6a", unit: "BV" },
  { address: "0x72a94b4e6598bce5dcfda586af4067f1a4019dc9", unit: "BV" },
  { address: "0x6d885b0b37c62be0c72ecd6a61af2bfff681419e", unit: "STC08375" },
  { address: "0x74b1254b5bbe423ca291bac73103fe351f347f24", unit: "STC" },
  { address: "0x8b64fd6a8d37bd95f54d9f888081408c6fac0819", unit: "转账助手" },
  { address: "0x59d3968ed4cfda51fdb5a2fb978d94f15f97e6b1", unit: "PB" },
  { address: "0xc8bf3c96df009451858b1884ec28710cf55836fd", unit: "PB" },
  { address: "0xbc115d6f44fd3a8077ac8206ec2826bd92feadfa", unit: "PB" },
  { address: "0x20d13894a7b7f585a0f3c10cb9cd93c5797db7e2", unit: "PB" },
  { address: "0x10a9c42f32497e85b51e2963297929d3ba3ec347", unit: "PB" },
  { address: "0x388a2a1c44a973ff1b3f4a225750e9ac48dd5907", unit: "ZNT" },
  { address: "0xa0e8250dc7609e7984887c0a8968298fbca0daec", unit: "TVY" },
  { address: "0xaed0aee35ed3fd0044eefdd7c8db059cff859be8", unit: "MIT" },
  { address: "0x106e0182c44a9218ea1eaede3199e437050ccd00", unit: "MIT" },
  { address: "0xdc590f520eceaad31c8daf0880bace80c1b12176", unit: "PCNB" },
  { address: "0xe5c7a2ea4f293d1caa4611f12fbe43c1a9e524d8", unit: "PCNB" },
    
];


// HLT 0x9Fa03dFc03Dc965759196231eFcc425C8085CE46
// BV 0x65fbc0125287689C81Be9138979A17543aa63D9f
// dUSDT 0x99bc001a7e274775DcC28eB4283B015Cb69840e4
// dBTC 0xb6476d01b67Bce545923d31E731CBae3860aF315
// dETH 0x7d0a5f4Cb8aB14525Dd8de6703126DaE0f7D551B
// DOS 0x16Da992C608fdb38966c77b93C1F301D995f9B17
// CNV 0x2cb76cCE32aCDA7263262117df1Bd02Ec54dcf5C
// FEC 0xf5Da17e859e8798157bc401e47D9Acd9485AE422
// STC 0x74B1254b5bbE423cA291BAc73103fE351F347f24

/**
 * 代币精度
 * DOS CNV HLT BV 2位
 * FEC 4 位
 * dUSDT 6 位
 * dBTC 8 位
 * dETH 18位
 * **/
export const amountAccuracy = {
  DOS: 100,
  CNV: 100,
  HLT: 100,
  PB: 100,
  FEC: 10000,
  dUSDT: 1000000,
  dBTC: 100000000,
  dETH: 1000000000000000000,
  DTT: 1000000000000000000,
  BV: 100,
  STC: 1,
  STC08375: 1,
  ZNT: 1000000000000000000,
  TVY: 1000000000000000000,
  MIT:10000,
  PCNB:100000000,
};

// 转账类型
export const transactionObj = {
  zh: {
    'transfer': "通证转帐",
    "0x40c10f19": "通证生成",
    "0xa9059cbb": "通证转帐",
    "0x9dc29fac": "通证销毁",
    "0x095ea7b3": "通证授权",
    "0xcf6c62ea": "兌换添加流动性",
    "0xfe029156": "兑换",
    "0xf2fde38b": "轉移持有者",
    '0x23b872dd': "通证转帐",
    '0xbeabacc8': "通证转帐",
    '0xd4c19bda': "updatePrice",
    '0x00f714ce': "withdraw",
    '0xf6b911bc': "burn",
    '0x7deb6025': "buy",
    '0xae1c7a66': "withdrawDTT",
    '0x67427169': "0x67427169",
    '0xe4849b32': "sell",
  },
  en: {
    'transfer': "transfer",
    "0x40c10f19": "mint",
    "0xa9059cbb": "transfer",
    "0x9dc29fac": "burn",
    "0x095ea7b3": "approve",
    "0xcf6c62ea": "addLiquidity",
    "0xfe029156": "swap",
    "0xf2fde38b": "transferOwnership",
    '0x23b872dd': "transfer",
    '0xbeabacc8': "transfer",//工具合约的 ETH 转账
    '0xd4c19bda': "updatePrice",
    '0x00f714ce': "withdraw",
    '0xf6b911bc': "burn",
    '0x7deb6025': "buy",
    '0xae1c7a66': "withdrawDTT",
    '0x67427169': "0x67427169",
    '0xe4849b32': "sell",
  },
};
